import { numEs } from './utils';

/**
 * The next step up on the karma board, from /karma/me's `next`.
 *
 * The server names the person above only when they are in the public top ten (the privacy
 * policy's promise, Legal.js «Datos visibles para otros vecinos»); below that it sends the gap
 * alone. So: «te faltan 7 puntos para alcanzar a Ana» near the top, «te faltan 7 puntos para
 * subir un puesto» everywhere else.
 *
 * Returns the three parts separately so the board can put the amount in bold, or null when
 * there is no step (first place, or an account the ranking leaves out).
 */
export function karmaNextStep(next) {
  const gap = Number(next?.gap);
  if (!next || !Number.isFinite(gap) || gap <= 0) return null;
  const nombre = (next.nombre || '').trim();
  return {
    lead: gap === 1 ? 'te falta' : 'te faltan',
    amount: `${numEs(gap)} ${gap === 1 ? 'punto' : 'puntos'}`,
    goal: nombre ? `para alcanzar a ${nombre}` : 'para subir un puesto',
  };
}
